import $ from "jquery";

export default class VerticalHandler {
	onVerticalChange (handler) {
		$(document).on("verticalChanged", (e, verticalSlug) => {
			handler(verticalSlug);
		});
	}

	changeVertical (vertical) {
		$(document).trigger("verticalChanged", [vertical]);
	}
}